<template>
  <div>
    <base-header type="gradient-success" class="pb-6">
    </base-header>
    <div class="container">
      <div class="container-fluid">
        <div class="row mt-5">
          <div class="col-3">
            <label>Version de consulta</label>

            <multiselect v-model="versionselect" :options="versions" :searchable="false"
                         :close-on-select="true" :show-labels="false"
                         track-by="id" label="name"
                         placeholder="Seleccionar Version"></multiselect>
          </div>
          <div class="col-md-3 col-lg-3 col-sm-12">
            <label class="typo__label">Repartidor</label>
            <multiselect
                v-model="dealer"
                :options="dealers"
                :custom-label="customLabel"
                :searchable="true"
                :close-on-select="true"
                track-by="user_id" label="last_name"
                placeholder="Seleccionar uno">
            </multiselect>
          </div>
          <div class="col-md-4 col-lg-4 col-sm-12">
            <label>Estado de ordenes</label>
            <multiselect v-model="orderselect" :options="orderstatus" :searchable="false"
                         :close-on-select="true" :show-labels="false"
                         track-by="order_status_id" label="status"
                         placeholder="Seleccionar Estado"></multiselect>
          </div>
          <div class="col-md-2 col-lg-2 col-sm-12 p-2">
            <base-button class="mt-4" id="search" @click="search">Buscar</base-button>
          </div>
          <div class="col-12">
            <base-alert type="danger" v-if="mensaje !=''">{{ mensaje }}</base-alert>

          </div>
        </div>
        <div v-if="orders.length > 0">
          <div class="row text-right">
            <div class="col-12">
              <div>
                <base-button icon="fa fa-print" size="sm" @click="print" class="mt-3">Imprimir</base-button>
              </div>
            </div>
          </div>
          <div class="row" id="printMe">
            <div class="col-12">
              <table class="mt-3" v-for="(order,index) in orders" :key="index" border="1" width="100%">
                <tr>
                  <td width="50%" colspan="2"><h3>{{ order.name }}</h3></td>
                  <td width="20%"><h3>Orden: {{ order.order_id }}</h3></td>
                  <td width="30%" colspan="2"><h3>Repartidor: {{ order.dealer }}</h3></td>

                </tr>
                <tr>
                  <td width="20%"><h4>Prioridad: {{ order.priority }}</h4></td>
                  <td width="40%" colspan="2"><h4>Hora Inicial</h4></td>

                  <td width="40%" colspan="2"><h4>Hora Final</h4></td>

                </tr>
                <tr>
                  <td width="20%"><h4>Dirección</h4></td>
                  <td width="80%" colspan="4">{{ jsonparse(order.shipping) }}</td>
                </tr>
                <tr v-for="(item,index) in order.products" :key="index">
                  <td width="40%" colspan="2">{{ item.nameproduct }}</td>
                  <td width="40%" colspan="2">{{ item.nota }}</td>
                  <td width="20%">{{ item.quantity + ' ' + item.unit }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div v-if="noresult">
          <span>No se encontraron resultados</span>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import {bus} from '../../components/Dealers/bus-dealers'
import {dealers_service} from "@/services/dealers/DealersService";
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';
import swal from 'sweetalert';
import {order_service} from "@/services/order/OrderService";
import _ from 'lodash'

const options = {
  name: '_blank',
  specs: [
    "fullscreen=yes",
    "titlebar=yes",
    "scrollbars=yes"
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "rutas.css"
  ]

}
Vue.use(VueHtmlToPaper, options);

export default {
  name: "Rutas",
  data() {
    return {
      versions: [
        {name: 'Cantidad pedida', id: 1},
        {name: 'Cantidad enviada', id: 2}
      ],
      versionselect: [],
      orderstatus: [],
      orderselect: '',
      dealers: [],
      dealer: [],
      user_session: [],
      data: [],
      date: '',
      mensaje: '',
      orders: [],
      noresult: false,
      config: {
        mode: "range",
        enableTime: true,
        dateFormat: "Y-m-d H:i:ss",
        allowInput: true,
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
            longhand: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
          },
          months: {
            shorthand: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Оct', 'Nov', 'Dic'],
            longhand: ['Enero', 'Febreo', 'Мarzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          },
        }
      }
    }
  },
  methods: {
    customLabel({name, last_name}) {
      return `${name} ${last_name}`
    },
    print() {
      // Pass the element id here
      swal("¿Desea marcar como enviadas estas ordenes?", {
        buttons: {
          cancel: "Solo imprimir",
          Aceptar: true,
        },
      })
          .then((value) => {
            switch (value) {

              case "Aceptar":
                for (const prop in this.orders) {
                  this.data.push({
                    'OrderStatus': {'order_status_id': 2},
                    'order_id': Number(this.orders[prop].order_id),
                    'user_id': this.user_session.user_id
                  })
                }
                order_service.UpdateOrderStatus(this.data)
                this.$htmlToPaper('printMe');
                this.data = []
                break;
              default:
                this.$htmlToPaper('printMe');

            }
          });
      //this.$htmlToPaper('printMe');
    },
    search() {
      if (this.dealer != null && this.orderselect.order_status_id > 0) {
        this.mensaje = ''
        //this.date = this.date.split(" to ")
        let data = {
          state: this.orderselect.order_status_id,
          user_id: this.dealer.user_id
        }
        if (this.dealer.user_id === 0) {
          if (this.versionselect.id === 1) {
            dealers_service.GetRepartidorAllOrderV1(data)
          } else {
            dealers_service.GetRepartidorAllOrder(data)
          }

        } else {
          if (this.versionselect.id === 1) {
            dealers_service.GetRepartidorOrderV1(data)
          } else {
            dealers_service.GetRepartidorOrder(data)
          }

        }

      } else {
        this.mensaje = 'Debe seleccionar el Repartidor y la fecha'
      }
    },
    jsonparse(arr) {
      const address = JSON.parse(arr)
      return address[0].address + '. Entregar a: ' + address[0].deliver_to
    }
  },
  created() {
    this.user_session = JSON.parse(sessionStorage.getItem('user'))
    dealers_service.GetAllOrderStatus()
    bus.$on('GetAllOrderStatus', (response) => {
      this.orderstatus = response
    })
    dealers_service.GetAllDealerInforme()
    bus.$on('GetAllDealerInforme', (response) => {
      const all = _.filter(response, i => {
        return i.user_id === 0
      })
      if (all.length === 0) {
        response.push({'user_id': 0, 'name': 'Todas las rutas', 'last_name': ''})
      }
      this.dealers = response
    })
    bus.$on('GetRepartidorOrder', (response) => {
      //console.log(response)
      if (response.length === 0) {
        this.noresult = true
        this.orders = []
        this.data = []
      } else {
        this.noresult = false
        var result = _.chain(response).groupBy("order_id").map(function (v, i) {
          return {
            order_id: i,
            name: _.get(_.find(v, 'name'), 'name'),
            dealer: _.get(_.find(v, 'dealer'), 'dealer'),
            priority: _.get(_.find(v, 'priority'), 'priority'),
            shipping: _.get(_.find(v, 'shipping'), 'shipping'),
            products: _.map(v)
          }
        }).value();
        this.orders = _.orderBy(result, ['dealer','priority'], ['asc', 'asc'])
      }
    })
  },
  updated() {

  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>
